import { useState } from 'react';

const STORAGE_KEY = 'activeTab';

export function useActiveTab(defaultTab = '') {
	const [activeTab, setActiveTabState] = useState<string>(() => {
		try {
			return localStorage.getItem(STORAGE_KEY) ?? defaultTab;
		} catch {
			return defaultTab;
		}
	});

	const setActiveTab = (value: string | ((prev: string) => string)) => {
		const newValue = typeof value === 'function' ? value(activeTab) : value;
		setActiveTabState(newValue);
		try {
			localStorage.setItem(STORAGE_KEY, newValue);
		} catch {
			// ignore storage errors
		}
	};

	return { activeTab, setActiveTab } as const;
}

export default useActiveTab;
